import { MarketingHeader } from "@/components/marketing/MarketingHeader";
import { MarketingFooter } from "@/components/marketing/MarketingSections2";
import CivilClusterContent from "@/components/marketing/CivilClusterContent";
import { SEO } from "@/lib/seo";
import { TRIAL_CTA } from "@/data/marketing";
import pages from "@/data/civilClusterPages.json";
import { civilClusterSchema } from "@/data/civilClusterSchema";
import "@/components/marketing/civilCluster.css";

export default function CivilClusterPage({ pageKey }) {
  const page = pages[pageKey];
  return <div className="web-site">
    <SEO title={page.title} description={page.description} path={page.path} jsonLd={civilClusterSchema(page)} />
    <a className="web-skip" href="#main-content">Skip to content</a>
    <MarketingHeader />
    <CivilClusterContent page={page} trialLabel={TRIAL_CTA} />
    <MarketingFooter />
  </div>;
}
